export const base64ToBlob = (base64: string, mimeType: string): Blob => {
  const byteArrays: number[] = [];
  const byteCharacters = atob(base64.split(',')[1]);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteArrays.push(byteCharacters.charCodeAt(i));
  }

  const byteArray = new Uint8Array(byteArrays);

  return new Blob([byteArray], { type: mimeType });
};
